import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HStack, Icon, IconButton, Input, InputGroup, Text, VStack, Wrap, WrapItem } from '@chakra-ui/react';
import { useState } from 'react';
import { FaSearch } from '@react-icons/all-files/fa/FaSearch';
export const TuneSelector = ({ tunes, activeTunes = [], onTune, onClose }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };
    const filteredTunes = tunes.filter(tune => {
        if ('type' in tune && tune.type === 'groupTune') {
            return tune.tunes.some(subTune => subTune.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                subTune.label?.toLowerCase().includes(searchTerm.toLowerCase()));
        }
        else {
            return (tune.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                tune.label.toLowerCase().includes(searchTerm.toLowerCase()));
        }
    });
    const handleTune = (info) => {
        info.tune.onTune?.();
        onTune({
            name: info.tune.name,
            groupName: info.group?.name,
            isActive: info.isActive
        });
        onClose();
    };
    return (_jsxs(VStack, { p: "3", rounded: "xl", bg: "white", w: "48", maxW: "300px", shadow: "lg", border: "1px", borderColor: "gray.100", children: [_jsx(InputGroup, { rounded: "md", startElement: _jsx(FaSearch, { color: "gray.300" }), children: _jsx(Input, { size: "sm", placeholder: "Search", value: searchTerm, onChange: handleSearch, px: "10", py: "1", bg: "gray.50", _hover: {
                        bg: 'gray.100'
                    }, _focus: {
                        bg: 'gray.100',
                        boxShadow: 'outline'
                    } }) }), _jsx(VStack, { w: "100%", align: "flex-start", gap: "1", maxH: "xs", overflowY: "auto", children: filteredTunes.map((tune, index) => {
                    if ('type' in tune && tune.type === 'groupTune') {
                        return (_jsxs(VStack, { w: "full", children: [_jsx(Text, { fontSize: "sm", asChild: true, children: _jsx("b", { children: tune.label }) }), _jsx(Wrap, { gap: "1", children: tune.tunes.map((subTune, subIndex) => {
                                        const isActive = activeTunes.some(activeTune => activeTune.name === subTune.name &&
                                            activeTune.groupName === tune.name);
                                        const isDisabled = isActive && subTune.isDisableOnActive;
                                        const isHidden = isActive && subTune.isHiddenOnActive;
                                        return (_jsx(WrapItem, { display: isHidden ? 'none' : 'flex', children: _jsx(IconButton, { size: "sm", variant: "ghost", "aria-label": `${subTune.name}`, ...(isActive && {
                                                    bg: 'gray.100',
                                                    cursor: 'pointer'
                                                }), disabled: isDisabled, onClick: () => {
                                                    handleTune({ tune: subTune, group: tune, isActive });
                                                }, children: _jsx(Icon, { asChild: true, children: _jsx(subTune.Icon, {}) }) }) }, subIndex));
                                    }) })] }, index));
                    }
                    if ('type' in tune && tune.type === 'tune') {
                        const isActive = activeTunes.some(activeTune => activeTune.name === tune.name);
                        const isDisabled = isActive && tune.isDisableOnActive;
                        const isHidden = isActive && tune.isHiddenOnActive;
                        return (_jsxs(HStack, { display: isHidden ? 'none' : 'flex', rounded: "md", w: "100%", p: "2", transition: "all 0.2s", _hover: {
                                bg: 'gray.100'
                            }, ...(isActive && {
                                bg: 'gray.100',
                                cursor: 'pointer'
                            }), ...(isDisabled && {
                                opacity: 0.5,
                                cursor: 'not-allowed'
                            }), onClick: () => {
                                if (!isDisabled) {
                                    handleTune({ tune, isActive });
                                }
                            }, children: [tune.Icon && (_jsx(Icon, { asChild: true, children: _jsx(tune.Icon, {}) })), _jsx(Text, { fontSize: "sm", children: tune.name })] }, index));
                    }
                    return null;
                }) })] }));
};
